import ProductCardSelectors from '../shared/product-card/selectors';
import OneClickCheckoutHandler from '../shared/product/one-click-checkout/button-handler';
import { PRODUCT_CARD_V3 } from '../classnames/product-card';
import { SubscriptionCard } from './subscription-card';
import SubscriptionHandler from '../shared/product/subscription-handler';

export class ProductCardV3 {
  constructor() {
    this.selectors = new ProductCardSelectors();
    this.containers = [...document.getElementsByClassName(PRODUCT_CARD_V3)];
    this.oneClickCheckoutHandler = new OneClickCheckoutHandler(this.selectors);
    this.subscriptionCard = new SubscriptionCard(this.containers);
  }

  initializeEventListeners = () => {
    this.oneClickCheckoutHandler.initializeEventListeners();
    this.subscriptionCard.initializeEventListeners();
    this.containers.forEach((container) => {
      new SubscriptionHandler(container).initializeEventListeners();
    });
  };
}
